import React from 'react'

const DoesNotStartsWith = ({ property, onChange }) => {
  return (
    <div />
  )
}

export default DoesNotStartsWith